import ApiService from "./base";
import { config } from "@/utils/config";
export default class LicensesService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getLicensesByContract(contractId, status) {
        const params = new URLSearchParams();
        if (status) params.append("status", status);
        const query = params.toString() ? `?${params.toString()}` : "";
        const response = await this.get({
            url: `/direct/contracts/${contractId}/licenses${query}`
        });
        return response.data;
    }
    async generateLicense(contractId, licenseAnchors) {
        const response = await this.post({
            url: `/direct/contracts/${contractId}/licenses`,
            data: {
                license_anchors: licenseAnchors
            }
        });
        return response.data;
    }
    async regenerateLicense(contractId, licenseAnchors) {
        const response = await this.post({
            url: `/direct/contracts/${contractId}/licenses/regenerate`,
            data: {
                license_anchors: licenseAnchors
            }
        });
        return response.data;
    }
    async downloadLicense(licenseId, customerId) {
        const params = new URLSearchParams();
        if (customerId) params.append("customerId", customerId);
        const query = params.toString() ? `?${params.toString()}` : "";
        const response = await this.get({
            url: `/direct/licenses/${licenseId}/download${query}`,
            config: {
                responseType: "blob"
            }
        });
        return response.data;
    }
}
